import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import api from './services/api';
import i18n from './i18n';
import ElementUILocaleZh from 'element-ui/lib/locale/lang/zh-CN';
import ElementUILocaleEn from 'element-ui/lib/locale/lang/en';
import '@/styles/variables.scss';
import '@/styles/global.scss';
import { initVersionCheck } from '@/utils/versionCheck';

// ⭐ 引入 Element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// ⭐ 导入权限指令
import permissionDirective from '@/directives/permission';


Vue.config.productionTip = false;

// 将 API 注册为全局属性
Vue.prototype.$api = api;

// ⭐ Element UI locale
function setElementUILocale() {
  const lang = localStorage.getItem('app_language') || 'zh-CN';
  const locale = lang === 'en-US' ? ElementUILocaleEn : ElementUILocaleZh;
  Vue.use(ElementUI, { 
    size: 'medium',
    locale
  });
}
setElementUILocale();

// ⭐ 语言切换方法
Vue.prototype.$switchLang = function(lang) {
  i18n.locale = lang;
  localStorage.setItem('app_language', lang);
  location.reload();
};

// ⭐ 语言切换方法（不刷新，仅更新 i18n）
Vue.prototype.$setLang = function(lang) {
  i18n.locale = lang;
  localStorage.setItem('app_language', lang);
};

// ⭐ 设置 MessageBox 的默认 z-index（高于购物车弹窗）
import { MessageBox } from 'element-ui';
MessageBox.setDefaults({
  customClass: 'custom-message-box',
  lockScroll: false
});

// ⭐ 注册权限指令
Vue.directive('permission', permissionDirective);

// ⭐ 使用 Element UI 的消息提示（替换自定义的 toast 和 message）
// Element UI 已经提供了 $message 和 $notify
// 添加 $toast 作为 $message 的别名，保持代码兼容性
import { Message } from 'element-ui';

Vue.prototype.$toast = {
  success(message) {
    Message.success({ message, duration: 3000 });
  },
  error(message) {
    Message.error({ message, duration: 3000 });
  },
  warning(message) {
    Message.warning({ message, duration: 3000 });
  },
  info(message) {
    Message.info({ message, duration: 3000 });
  }
};

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');

// 初始化版本检查
initVersionCheck();
